var exports = {
  "m": "Wrapper__mhjhvD",
  "H": "Canvas__twDv-7",
};

module.exports = exports;
